import React from "react"
//import I18n from "i18n-js/index.js.erb"
// import DatePicker from "../DatePicker/DatePicker"
import NumberSpinner from "../NumberSpinner/NumberSpinner"
import EmailCampaignBuilderCustomersSelect from "./EmailCampaignBuilderCustomersSelect"

export default class EmailCampaignBuilderCustomers extends React.Component{
  constructor(props){
    super(props);
    this.renderCustomerSelectBoxes = this.renderCustomerSelectBoxes.bind(this)
  };

  render(){
    return(
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default" style={{ marginBottom: 0 }}>
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6">
                  <h3 className="panel-title">
                    {I18n.t('customer_details')}
                  </h3>
                </div>
                <div className="col-md-6 content-right flexed">
                  <div className="add-button"><button type="button" className="btn btn-secondary" onClick={this.props.onAddField}>{I18n.t('add')}</button></div>
                </div>
                <div className="clearfix"></div>
              </div>
              {this.renderCustomerSelectBoxes()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderCustomerSelectBoxes(){
    var customerSelectBoxes = this.props.customerSelectBoxes.map((select, idx) => {
      var options = []
      var additional_questions = false

      this.props.allCustomerFields.map((field, idx) => {
        if (!this.props.customerFields.hasOwnProperty(field.column) || select.value == field.column) {
          if(!field.additional_question) {
            options.push(<option key={idx} name={field.column}>{field.column}</option>)
          } else {
            additional_questions = true
          }
        }
      })

      if (additional_questions) {
        options.unshift(<option key="additional_questions" name="additional_questions">{I18n.t('customer_fields')}</option>)
      }

      options.unshift(<option key="disabled" disabled="disabled">{I18n.t('select_ellipsis')}</option>)
      return (
        <div key={idx} className="col-md-12">
          <div className="pull-right" style={{ marginTop: '25px' }}><button type="button" className="btn btn-dark btn-sm" style={{ paddingLeft: '7px', paddingRight: '7px' }} onClick={e => this.props.removeField(idx)}>{I18n.t('remove')}</button></div>
          <div className="col-md-2">
            <label style={{ marginTop: '15px' }}>{`${I18n.t('columns')}*`}</label>
            <div className="form-group">
              <select id={select.id} className={this.fieldErrors(select.id) ? 'form-control has-errors' : 'form-control'} onChange={this.props.onChangeSelect} value={select.value || I18n.t('select_ellipsis')}>{options}</select>
              {
                this.fieldErrors(select.id)
              }
            </div>
          </div>
          {this.renderField(select.value, select.id)}
        </div>
      )
    });

    return customerSelectBoxes
  }

  renderField(value, id = null){
    if (value == I18n.t('customer_fields')) {
      return this.renderAdditionalQuestions(id)
    }

    for (var i = 0, ilen = this.props.allCustomerFields.length; i < ilen; i++) {
      var field = this.props.allCustomerFields[i]
      if(field.column == value) {
        if (field.column_type == "Date Field") {
          return this.renderDateFieldOptions(value, id)
        } else if (field.column_type == "Number") {
          return this.renderNumberField(value, id)
        } else if(["Text Field", "Text Area", "Select Box"].includes(field.column_type)){
          return this.renderFieldSelect(value, id)
        }
      }
    }
  }

  renderAdditionalQuestions(id){
    var select = this.props.customerSelectBoxes.filter(select => select.id === id)[0]
    var options = []

    this.props.allCustomerFields.map((field, idx) => {
      if (field.additional_question) {
        if (!this.props.customerFields.hasOwnProperty(field.column) || select.additional_question_value == field.column) {
          options.push(<option key={idx} name={field.column}>{field.column}</option>)
        }
      }
    })

    options.unshift(<option key="disabled" disabled="disabled">{I18n.t('select_ellipsis')}</option>)
    return (
      <div>
        <div className="col-md-2">
          <label style={{ marginTop: '15px' }}>{`${I18n.t('customer_fields')}*`}</label>
          <div className="form-group">
            <select className={this.fieldErrors(id + "additional_column") ? 'form-control has-errors' : 'form-control'} onChange={(e) => this.props.onChangeAdditionalQuestionsSelect(e, select.id)} value={select.additional_question_value || I18n.t('select_ellipsis')}>{options}</select>
            {
              this.fieldErrors(id + "additional_column")
            }
          </div>
        </div>
        {this.renderField(select.additional_question_value, id)}
      </div>
    )
  }

  renderDateFieldOptions(value, id){
    return (
      <div>
        <div className="col-md-4">
          <div className="form-group row">
            <div className="col-md-6">
              <label style={{ marginTop: '15px' }}>{`${I18n.t('from')}`}</label>

              <DatePicker
                // ref="exact_start_date"
                className={this.fieldErrors(id + "column") ? 'campaign-date-field has-errors' : 'campaign-date-field'}
                name={`${value}_from`}
                value={this.props.customerFields[value] && this.props.customerFields[value].from ? this.props.customerFields[value].from : ''}
                dateFormat={this.props.date_format}
                onChange={this.props.onChangeCustomerFieldDate} />
              {
                this.fieldErrors(id + "column")
              }
            </div>

            <div className="col-md-6">
              <label style={{ marginTop: '15px' }}>{`${I18n.t('to')}`}</label>

              <DatePicker
                // ref="exact_end_date"
                className={this.fieldErrors(id + "column") ? 'campaign-date-field has-errors' : 'campaign-date-field'}
                name={`${value}_to`}
                value={this.props.customerFields[value] && this.props.customerFields[value].to ? this.props.customerFields[value].to : ''}
                dateFormat={this.props.date_format}
                onChange={this.props.onChangeCustomerFieldDate} />
              {
                this.fieldErrors(id + "column")
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderNumberField(value, id){
    return (
      <div>
        <div className="col-md-4">
          <div className="form-group row">
            <div className="col-md-6">
              <label style={{ marginTop: '15px' }}>{I18n.t("option")}</label>
              <select
                value={this.props.customerFields[value] && this.props.customerFields[value].option ? this.props.customerFields[value].option : 'select_ellipsis'}
                onChange={(e) => this.props.onChangeNumberField(e, value + "_option")}
                id={value}
                className={this.fieldErrors(id + "column") || this.fieldErrors(id + "option") ? 'form-control has-errors' : 'form-control'}>
                <option value='select_ellipsis' disabled="disabled">{I18n.t('select_ellipsis')}</option>
                <option value="less_than">{I18n.t('less_than')}</option>
                <option value="less_than_or_equal_to">{I18n.t('less_than_or_equal_to')}</option>
                <option value="equal_to">{I18n.t('equal_to')}</option>
                <option value="greater_than_or_equal_to">{I18n.t('greater_than_or_equal_to')}</option>
                <option value="greater_than">{I18n.t('greater_than')}</option>
              </select>
              {this.fieldErrors(id + "column")}
              {this.fieldErrors(id + "option")}
            </div>

            <div className="col-md-6">
              <label style={{ marginTop: '15px' }}>{I18n.t("number_string")}</label>
              <NumberSpinner onChange={(e) => this.props.onChangeNumberField(e, value + "_number")} id={value + "_spinner"} name={value} className={this.fieldErrors(id + "column") || this.fieldErrors(id + "number") ? 'filter form-control has-errors' : 'filter form-control'} max={999999} value={this.props.customerFields[value] && this.props.customerFields[value].number ? this.props.customerFields[value].number : ""} />
              {this.fieldErrors(id + "column")}
              {this.fieldErrors(id + "number")}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderFieldSelect(value, id){
    if (value) {
      var selections = this.props.customerFields[value] || []
      return (
        <div className="col-md-4">
          <label style={{ marginTop: '15px' }}>{`${I18n.t('column')} ${I18n.t('value')}*`}</label>
          <EmailCampaignBuilderCustomersSelect selections={selections} column={value} onChange={this.props.onChangeSelections} className={this.fieldErrors(id + "column") ? 'has-errors' : ''}/>
          {
            this.fieldErrors(id + "column")
          }
        </div>
      )
    }
  }

  fieldErrors(field) {
    if (this.props.errors[field]) {
      return (
        <div className="help-block">
          <ul>{this.props.errors[field]}</ul>
        </div>
      )
    } else {
      return false
    }
  }

};
